import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, action }) => (
  <Box
    sx={{
      py: 8,
      px: 3,
      textAlign: 'center',
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 2,
      backgroundColor: 'background.paper',
    }}
  >
    <InboxOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
    <Typography variant="h3" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: action ? 2 : 0 }}>
        {description}
      </Typography>
    )}
    {action}
  </Box>
);

export default EmptyState;
